/*
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-07-14 17:19:10
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-17 13:52:05
 * @FilePath: \fe-frame-page\src\api\enterpriseHighNew.js
 * @Description:高新技术企业测评接口
 */
import request from "@/utils/request";
import znRequest from "@/utils/znRequest";

//企业测评工具-高新企业测评
export function highTechEnterpriseEva(data) {
  return request({
    url: `/evaTool/highTechEnterpriseEva`,
    method: "post",
    data,
  });
}

// 获取公司列表
export function getCompanyInfo(data) {
  return request({
    url: `/report/getCompanyInfo/companyName`,
    method: "post",
    data,
  });
}

// 获取工商信息
export function getCorpInfo(params) {
  return request({
    url: `/corp/detail`,
    method: "get",
    params,
  });
}

// 基础班测评
export function highTechEnterpriseEvaBasis(data) {
  return znRequest({
    url: `/evaTool/highTechEnterpriseEva/v2/basis`,
    method: "post",
    data,
  });
}

// 完整版测评
export function highTechEnterpriseEvaFull(data) {
  return znRequest({
    url: `/evaTool/highTechEnterpriseEva/v2/full`,
    method: "post",
    data,
  });
}

// 获取报告数据
export function reportDataApi(data) {
  return znRequest({
    url: "/report/viewReport",
    method: "post",
    data,
  });
}

// 今日留咨信息
export function statisticsApi(params) {
  return znRequest({
    url: `/comment/report/statistics`,
    method: "get",
    params,
  });
}

// 留咨
export function advisoryApi(data) {
  return znRequest({
    url: `/evaTool/report/advisory`,
    method: "post",
    data,
  });
}

// 是否留咨询
export function isAdvisoryApi(params) {
  return znRequest({
    url: `/comment/advisory`,
    method: "get",
    params,
  });
}
